module.exports = __webpack_public_path__ + "img/insurreport-thumbnail.5975e4b8.png";